import React, { useState, useContext, useRef, useEffect } from 'react';

import { CloseIcon } from '@zola/zola-ui/src/components/SvgIcons/Close';
import { usePrevious } from '@zola/zola-ui/src/hooks';

import type { BannerAnimationProps } from 'components/publicWebsiteV2/@types';

import { ThemeContext } from 'components/publicWebsiteV2/context';

import { Container, Text, CloseBtn, ICON_SIZE } from './Banner.styles';

const Banner = ({
  bannerHeight,
  isAnimating,
  setBannerHeight,
  onAnimationFinish,
}: BannerAnimationProps): JSX.Element | null => {
  /* Product has requested that we put dismissable on pause; Leaving in code to activate later */
  const isDismissable = false;
  const bannerRef = useRef<HTMLDivElement>(null);
  const [showBanner, setShowBanner] = useState(true);
  const prevHeight = usePrevious(bannerHeight);

  const handleClose = () =>
    onAnimationFinish(() => {
      setBannerHeight(0);
      setShowBanner(false);
    });

  const {
    wedding,
    light_or_dark,
    components: { cmsEntityComponentBodyFontValues },
  } = useContext(ThemeContext);
  const { enable_cms_banner: bannerCMSEnabled, cms_banner_message: bannerText } = wedding || {};

  useEffect(() => {
    // usePrevious is undefined if 0 is passed. Seems like a bug
    if (prevHeight === undefined && bannerRef.current)
      setBannerHeight(bannerRef.current?.clientHeight);
  }, [prevHeight, bannerRef, setBannerHeight]);

  if (!bannerCMSEnabled || !showBanner) return null;

  return (
    <Container
      mode={light_or_dark}
      color={cmsEntityComponentBodyFontValues.color}
      isAnimating={isAnimating}
      height={bannerHeight}
      ref={bannerRef}
    >
      <Text>{bannerText}</Text>
      {isDismissable && (
        <CloseBtn onClick={handleClose} data-testid="close">
          <CloseIcon height={ICON_SIZE} width={ICON_SIZE} />
        </CloseBtn>
      )}
    </Container>
  );
};

export default Banner;
